"use client";

import React from "react";
import { Dialog, Modal } from "staysure-component-library";

import WithdrawalModalContent from "./withdrawal-modal-content";

interface WithdrawalModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  content: {
    modalTitle: string;
    modalContent: string;
    modalCloseButtonLabel: string;
  };
}

function WithdrawalModal({
  isOpen,
  setIsOpen,
  content,
}: Readonly<WithdrawalModalProps>) {
  return (
    <Modal
      onOpenChange={(e: boolean) => setIsOpen(e)}
      isOpen={isOpen}
      modalStyles={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="bg-surface-neutral-option-1 w-[327px] md:w-[416px] items-center justify-center relative rounded-radius-lg"
      uderlayClassName="z-[200] bg-interactive-overlay-default"
    >
      <Dialog className="relative" data-testid="withdrawal-modal-dialog">
        <WithdrawalModalContent
          modalTitle={content.modalTitle}
          modalContent={content.modalContent}
          modalCloseButtonLabel={content.modalCloseButtonLabel}
          setIsOpen={setIsOpen}
        />
      </Dialog>
    </Modal>
  );
}

export default WithdrawalModal;
